import React, { lazy, Suspense } from "react";


import { CircularProgress, Box } from "@mui/material";
import Layout from "./../layout/Layout";
import AdminProtectedRoute from './AdminProtectedRoute';
import PublicOnlyRoute from './PublicOnlyRoute';
import AssignTemplateUser from "../components/BluckEmail/AssignTemplateUser/AssignTemplateUser";
import CreatorTemplate from "../components/BluckEmail/CreatorTemplate/CreatorTemplate";

// import AssignTemplateUserDetails from '../components/BluckEmail/AssignTemplateUserDetails'


import AssignRole from "../components/AssignRole/AssignRole";
import { Route, Routes } from "react-router-dom";

// Lazy loaded components
const Login = lazy(() => import("./../components/Login"));
const Dashboard = lazy(() => import("./../components/Dashboard"));
const CreateContract = lazy(() => import("./../components/CreateContract"));
const RequestContract = lazy(() => import("./../components/RequestContract"));
const ViewContract = lazy(() => import("./../components/ViewContract"));
const SendContract = lazy(() => import("./../components/SendContract"));
const UserList = lazy(() => import("./../components/UsersList"));
const UserDetail = lazy(() => import("./../components/UserDetails"));
const PersionalDetailsSurvey = lazy(() => import("../components/PersionalDetailsSurvey"));
const ConsumerDetailsSurvey = lazy(() => import("../components/ConsumerDetailsSurvey"));
const MoviesList = lazy(() => import("../components/MoviesList"));
const UserEaring = lazy(() => import("../components/UserEaring"));
const TransactionList = lazy(() => import("../components/TransactionList"));
const MoviesReviewList = lazy(() => import("../components/MoviesReviewList"));
const NewMoviesReviewList = lazy(() => import("../components/NewMoviesReviewList"));
const BusinessDetails = lazy(() => import("../components/BusinessDetails"));
const CreatorDetails = lazy(() => import("../components/CreatorDetails"));
const Others = lazy(() => import("../components/OthersDetails"));
const Shows = lazy(() => import("../components/Shows"));
const Videos = lazy(() => import("../components/video"));
const ShowDetails = lazy(() => import('../components/ShowDetails'));
const EpisodeDetails = lazy(() => import('../components/VideosDetails'));
const PublicShow = lazy(() => import("../components/PublicShows"));
const UploadContract = lazy(() => import('../components/UploadContract'));
const MoviesUserList = lazy(() => import("../components/MoviesUserList"));
const UpdateTemplate = lazy(() => import("../components/BluckEmail/UpdateTemplate/UpdateTemplate"));
const EmailUser = lazy(() => import("../components/BluckEmail/EmailUser/EmailUser"));
const UserEmailDetails = lazy(() => import("../components/UserEmailDetails/UserEmailDetails"));
const AllContactEmailUser = lazy(() => import("../components/BluckEmail/AllContactEmailUser/AllContactEmailUser"));

const PlucLabStory = lazy(() => import("../components/PluLabStory"))
const CreatorPlucUser = lazy(() => import("../components/CreatorPlucUser"))
const PlucStoryDetails = lazy(() => import("../components/PlucStoryDetails"))
const ScrollToTop = lazy(() => import("./../ScrollToTop"));
const Page404 = lazy(() => import("./../components/Page404"));
const PublicContract = lazy(() => import("../components/PublicContract"));
const MessageTemplate = lazy(() => import("../components/BulkWhatsAppMessage/WhatsappMessageTemplate/ViewMessageTemplate"));
const AllContactList = lazy(() => import("../components/BulkWhatsAppMessage/ContactList/AllContactList"));
const GetAllContactEmailUserDetails = lazy(() => import("../components/BluckEmail/AllContactEmailUser/GetAllContactEmailUserDetails"));

const GetUserWithRole = lazy(() => import("../components/GetUserWithRole/GetUserWithRole"));
const WhatsappMessageTemplate = lazy(() => import("../components/BulkWhatsAppMessage/WhatsappMessageTemplate/WhatsappMessageTemplate"));
const ContactList = lazy(() => import("../components/BulkWhatsAppMessage/ContactList/ContactList"));
const AddContactListMember = lazy(() => import("../components/BulkWhatsAppMessage/ContactList/AddContactListMember"));
const ContactListMember = lazy(() => import("../components/BulkWhatsAppMessage/ContactList/ContactListMember"));
const SutMessage = lazy(() => import("../components/BluckEmail/SutMessage/SutMessage"));
const ViewTemplate = lazy(() => import("../components/BluckEmail/ViewTemplate/ViewTemplate"));
const UserListAdd = lazy(() => import("../components/BluckEmail/EmailUser/UserListAdd/UserListAdd"));
const GetEmailListUser = lazy(() => import("../components/BluckEmail/EmailUser/GetListEmailUser/GetListEmailUser"));
const AssignTemplateUserDetails = lazy(() => import("../components/BluckEmail/AssignTemplateUserDetails/AssignTemplateUserDetails"));
const ServicesList = lazy(() => import("../components/Services/ServicesList"));

// LMS (training) screens
const LmsDashboard = lazy(() => import("../components/Lms/LmsDashboard"));
const LmsClasses = lazy(() => import("../components/Lms/LmsClasses"));
const LmsCreateClass = lazy(() => import("../components/Lms/LmsCreateClass"));
const LmsClassDetail = lazy(() => import("../components/Lms/LmsClassDetail"));
const LmsAttendance = lazy(() => import("../components/Lms/LmsAttendance"));
const LmsSessionDetail = lazy(() => import("../components/Lms/LmsSessionDetail"));
const LmsStudents = lazy(() => import("../components/Lms/LmsStudents"));
const LmsStudentDetail = lazy(() => import("../components/Lms/LmsStudentDetail"));
const LmsTrainers = lazy(() => import("../components/Lms/LmsTrainers"));
const LmsLeave = lazy(() => import("../components/Lms/LmsLeave"));
const LmsCancellations = lazy(() => import("../components/Lms/LmsCancellations"));
const LmsBroadcast = lazy(() => import("../components/Lms/LmsBroadcast"));
const LmsSubAdmins = lazy(() => import("../components/Lms/LmsSubAdmins"));

const CenteredLoading = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      width: '100%'
    }}
  >
    <CircularProgress size={60} />
  </Box>
);
export default function AppRoutes() {
  return (

    <Suspense fallback={<CenteredLoading />}>
      <ScrollToTop />
      <Routes>
        {/* Protected Routes */}
        <Route element={<Layout />}>
          <Route element={<AdminProtectedRoute />}>
            <Route index element={<Dashboard />} />
            <Route path="/create-contract" element={<CreateContract />} />
            <Route path="/request-contract" element={<RequestContract />} />
            <Route path="/contract-detail/:slug" element={<ViewContract />} />
            <Route path="/create-contract/:id" element={<SendContract />} />
            <Route path="/users-list" element={<UserList />} />
            <Route path="/user-detail/:id" element={<UserDetail />} />
            <Route path="/persional-survey" element={<PersionalDetailsSurvey />} />
            <Route path="/consumer-survey" element={<ConsumerDetailsSurvey />} />
            <Route path="/movies-list" element={<MoviesList />} />
            <Route path="/movies-review-list/:id" element={<MoviesReviewList />} />
            <Route path="/user-earning" element={<UserEaring />} />
            <Route path="/user-transaction" element={<TransactionList />} />
            <Route path="/movies-review" element={<NewMoviesReviewList />} />
            <Route path="/business" element={<BusinessDetails />} />
            <Route path="/creator" element={<CreatorDetails />} />
            <Route path="/others" element={<Others />} />
            <Route path="/shows" element={<Shows />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/show-detail/:id" element={<ShowDetails />} />
            <Route path="/episode-details/:id" element={<EpisodeDetails />} />
            <Route path="/public-show" element={<PublicShow />} />
            <Route path="/upload-contract" element={<UploadContract />} />
            <Route path="/movies-user-list/:id" element={<MoviesUserList />} />
            <Route path="/update-template/:id" element={<UpdateTemplate />} />
            <Route path="/email-user" element={<EmailUser />} />
            {/* <Route path="/user-details" element={<UserEmailDetails />} />  */}
            <Route path="/assign-template" element={<AssignTemplateUser />} />
            <Route path="/create-template" element={<CreatorTemplate />} />
            <Route path="/view-template" element={<ViewTemplate />} />
            <Route path="/user-details" element={<UserEmailDetails />} />
            <Route path="/assign-templateuser" element={<AssignTemplateUserDetails />} />
            <Route path="pluc-lab-stroy" element={<PlucLabStory />} />
            <Route path="/pluc-user" element={<CreatorPlucUser />} />
            <Route path="/pluc-story-details/:id" element={< PlucStoryDetails />} />
            <Route path="/email-user-list" element={<UserListAdd />} />
            <Route path="/user-list/:id" element={<GetEmailListUser />} />
            <Route path="/assign-role" element={<AssignRole />} />
            <Route path="/getuserwithrole-details" element={<GetUserWithRole />} />
            <Route path="/public-contract" element={<PublicContract />} />
            <Route path="/message-template" element={<WhatsappMessageTemplate />} />
            <Route path="/whatsapp-contact-list" element={<ContactList />} />
            <Route path="/view-template-message" element={<MessageTemplate />} />
            <Route path="/all-contact" element={<AllContactList />} />
            <Route path="/all-contacts" element={<AllContactEmailUser />} />
            <Route path="/all-contact-details/:id" element={<GetAllContactEmailUserDetails />} />
            <Route path="/shoot-email" element={<SutMessage />} />
            {/* <Route path="/contact" element={<Contact />} /> */}
            <Route path="/add-contact-list-member/:id" element={<AddContactListMember />} />
            <Route path="/contactlist-member/:id" element={<ContactListMember />} />
            <Route path="/services-list" element={<ServicesList />} />
            <Route path="/lms" element={<LmsDashboard />} />
            <Route path="/lms/classes" element={<LmsClasses />} />
            <Route path="/lms/classes/create" element={<LmsCreateClass key="create" />} />
            <Route path="/lms/classes/:id" element={<LmsClassDetail />} />
            <Route path="/lms/classes/:id/edit" element={<LmsCreateClass key="edit" />} />
            <Route path="/lms/attendance" element={<LmsAttendance />} />
            <Route path="/lms/attendance/:id" element={<LmsSessionDetail />} />
            <Route path="/lms/students" element={<LmsStudents />} />
            <Route path="/lms/students/:id" element={<LmsStudentDetail />} />
            <Route path="/lms/trainers" element={<LmsTrainers />} />
            <Route path="/lms/leave" element={<LmsLeave />} />
            <Route path="/lms/cancellations" element={<LmsCancellations />} />
            <Route path="/lms/broadcast" element={<LmsBroadcast />} />
            <Route path="/lms/sub-admins" element={<LmsSubAdmins />} />
          </Route>
        </Route>
        {/* Public Routes */}
        <Route element={<PublicOnlyRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>
        {/* Page 404 */}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </Suspense>

  );
}